import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        display: flex;
        flex-direction: column;
        align-items: center;
    `,
};
